import { HttpInterceptorFn, HttpEventType } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { AuthService } from '../auth/services/auth.service';
import { PortfolioContextService } from '../context/portfolio-context.service';
import { extrairContextoAuditavel } from './audit-context.util';
import {
  AuditService,
  extrairResourceId,
  inferirAcao,
  inferirDominio,
  inferirResourceType,
} from './audit.service';

const MUTATIONS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

export const auditInterceptor: HttpInterceptorFn = (request, next) => {
  const audit = inject(AuditService);
  const auth = inject(AuthService);
  const portfolioContext = inject(PortfolioContextService);

  if (!audit.enabled() || !request.url.includes('/api/v1/')) {
    return next(request);
  }

  if (request.url.includes('/api/v1/audit/')) {
    return next(request);
  }

  if (!MUTATIONS.has(request.method.toUpperCase())) {
    return next(request);
  }

  return next(request).pipe(
    tap((event) => {
      if (event.type !== HttpEventType.Response) {
        return;
      }
      const dominio = inferirDominio(request.url);
      const portfolioId =
        portfolioContext.portfolioIdAtivo() ?? auth.portfolioId() ?? undefined;
      const perfilAtivo = auth.perfilAuditoriaAtivo();
      const corpo = extrairContextoAuditavel(request.body);

      audit.enqueue({
        domain: dominio,
        resourceType: inferirResourceType(dominio),
        resourceId: extrairResourceId(request.url, dominio),
        action: inferirAcao(request.method),
        correlationId: request.headers.get('X-Correlation-Id') ?? undefined,
        context: {
          metodo: request.method,
          rota: request.url.split('?')[0],
          ...corpo,
          ...(portfolioId ? { portfolioId } : {}),
          ...(perfilAtivo ? { perfilAtivo } : {}),
        },
      });
    }),
  );
};
